import { useDrawer } from '@core/context/DrawerContext'
import { Wrapper, Flex } from '@ui/drawer/caseDetails/caseDetails.styles'
import ServiceRequestTabs from '@ui/drawer/serviceRequestDetails/components/serviceRequestTabs/serviceRequestTabs'
import { Body, Title } from './serviceRequest.styles'
import Markdown from 'react-markdown'

const ServiceRequest = () => {
    const { drawerState } = useDrawer()
    const { currentIndex, cases } = drawerState?.contentProps || {}
    const caseData = cases?.[currentIndex]

    if (!caseData) return null

    return (
        <Wrapper>
            <Body>
                <Flex>
                    <Title
                        variant="xs-regular"
                        testId="case-description"
                        component="span"
                        className="text"
                        noWrap={false}
                    >
                        <Markdown>{caseData.description}</Markdown>
                    </Title>
                </Flex>
                <ServiceRequestTabs serviceRequestData={caseData} />
            </Body>
        </Wrapper>
    )
}

export default ServiceRequest
